import moment from "moment";

export const minSelectionDate = moment().subtract(3, "years").format();
